var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllVendor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FDEDD5",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4633 14.0127H12.4383C11.5684 14.0127 10.8633 14.7178 10.8633 15.5877V22.6752C10.8633 23.545 11.5684 24.2502 12.4383 24.2502H23.4633C24.3331 24.2502 25.0383 23.545 25.0383 22.6752V15.5877C25.0383 14.7178 24.3331 14.0127 23.4633 14.0127Z",
    stroke: "#D98B17",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8008 14.0123V12.4373C14.8008 12.0196 14.9667 11.619 15.2621 11.3236C15.5575 11.0282 15.9581 10.8623 16.3758 10.8623H19.5258C19.9435 10.8623 20.3441 11.0282 20.6395 11.3236C20.9348 11.619 21.1008 12.0196 21.1008 12.4373V14.0123",
    stroke: "#D98B17",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9492 17.9502V17.9589",
    stroke: "#D98B17",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8633 18.7373C13.0617 19.8451 15.4891 20.4221 17.9508 20.4221C20.4125 20.4221 22.8399 19.8451 25.0383 18.7373",
    stroke: "#D98B17",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllVendor);
export default __webpack_public_path__ + "static/media/all_vendor.7c4c364027007f8b435165ff783eaf63.svg";
export { ForwardRef as ReactComponent };